'use strict';

const Alerts = require('lib/alerts');
const moment = require('moment');
var tooltip  = require('helpers/tooltip');
var inflect  = require('i')();
var Cocktail = require('lib/Cocktail');

var InputValueFormatMixin = require('commons/viewMixins/InputValueFormat');

module.exports = Cocktail.mixin(Backbone.View.extend({
    tainted: false,

    showAlert: function(message) {
        Alerts.show('error', {
            text: 'You\'re trying to save an incorrect data:\n' + message +
                '\n Please complete the form or\n' +
                'use a different value before continuing.',
        });
    },

    events: function() {
        return {
            /* js-ext class can be used by Views that extend this one
             * to provide custom behaviour to some fields if they don't
             * have a one to one match to a model's attribute or for whatever
             * reason.
             * */
            'change input:not(.js-icheck):not(.js-ext)': 'updateModel',
            'change textarea:not(.js-ext)':              'updateModel',
            'change select:not(.js-ext)':                'updateModel',
            'ifToggled input:not(.js-ext)':              'updateModel',
            'changeDate .js-datepicker:not(.js-ext)':    'updateDate',
            'change input,select,textarea':              'taint',
            'ifToggled input':                           'taint',

            'change .js-datepicker:not(.js-ext) .js-datepicker-input':
                'updateDateInput'
        };
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            templateExtra:      false,
            template:           null,
            radioClass:         'iradio_square-blue',
            checkboxClass:      'icheckbox_square-blue'
        });

        this.tainted = false;

        if (this.model) {
            this.bindHandlers();
            this.render();
        }

        return this;
    },

    bindHandlers: function() {
        this.model.on('invalid error', this.invalid, this);
        this.model.on('change', this.valid, this);
        this.model.on('change', this.renderAttributes, this);
        this.model.on('sync', this.render, this);
        this.model.on('sync', this.untaint, this);
        this.model.on('destroy', this.remove, this);
        this.model.on('alert', this.invalidAlert, this);

        return this;
    },

    unbindHandlers: function() {
        this.model.off(null, null, this);
        return this;
    },

    setModel: function(model) {
        if (this.model) {
            this.unbindHandlers();
        }

        this.model = model;
        this.bindHandlers();
        this.render();

        return this;
    },

    unsetModel: function() {
        this.unbindHandlers();
        this.model = undefined;

        return this;
    },

    render: function() {
        if (!this.options.template) {
            return this;
        }

        if (!this.model) {
            return this;
        }

        this.$el.html(this.options.template(
            _.defaults({model: this.model}, this.options.templateExtra || {})
        ));

        this.$('.js-icheck').iCheck({
            radioClass: this.options.radioClass,
            checkboxClass: this.options.checkboxClass
        });

        this.$('.js-datepicker')
            .addClass('js-ignore')
            .datepicker({
                autoclose: true,
                format: 'dd/mm/yyyy',
                keyboardNavigation: false,
                todayBtn: 'linked',
                todayHighlight: true
            })
            .removeClass('js-ignore');

        this.$('.js-chosen').chosen({width: '100%'});

        tooltip.init(this);

        return this;
    },

    renderAttributes: function(model) {
        const changes = model.changed || {};

        Object.keys(changes).forEach(attr => {
            const renderer = 'render' + inflect.camelize(attr);

            // if there is a renderer specified, use it
            if (typeof this[renderer] === 'function') {
                return this[renderer](model);
            }

            return this.renderAttribute(model, attr);
        });
    },

    renderAttribute: function(model, attr) {
        var $el = this.$('[name="' + attr + '"]');

        /* I *HATE* iCheck */
        if (
            $el.attr('type') === 'radio' &&
            $el.parent().attr('class').indexOf(this.options.radioClass) >= 0
        ) {
            var value =
                !_.isBoolean(model.get(attr)) ? model.get(attr) :
                (model.get(attr) === true) ? '1' : '0';

            this.$('[name="' + attr + '"][value="' + value + '"]')
                .iCheck('check');
        } else if (
            $el.attr('type') === 'checkbox' &&
            $el.parent().attr('class').indexOf(
                this.options.checkboxClass
            ) >= 0
        ) {
            this.$('[name="' + attr + '"]').iCheck(
                model.get(attr) ? 'check' : 'uncheck'
            );
        } else if ($el.hasClass('js-datepicker-input')) {
            $el.val(_.isFunction(model.getFormatted) ?
                model.getFormatted(attr, 'DD/MM/YYYY') : model.get(attr)
            );
        } else if (!_.isObject(model.get(attr)) && attr.slice(-2) !== 'Id') {
            this.$('[name=' + attr + ']').val(model.get(attr));
        }
    },

    updateDateInput: function(ev) {
        let $input = this.$(ev.currentTarget);
        let $datepicker = this.$(ev.currentTarget)
            .closest('.js-datepicker', this.el);
        let attr = $input.attr('name');

        if ($input.val() === '') {
            this.model.set(attr, null);
        } else {
            $datepicker.datepicker('setDate', $input.val());
        }
    },

    updateDate: function(ev) {
        var $input = this.$(ev.currentTarget).hasClass('js-datepicker-input') ?
            this.$(ev.currentTarget).closest('.js-datepicker', this.el) :
            this.$(ev.currentTarget);
        var $realInput = $input.find('input');
        let updateModel = () => {
            let validDate = moment(this.getInputValue($input))
                .isSame(moment($realInput.val(), 'DD/MM/YYYY'), 'day');
            if (validDate) {
                this.updateModel.apply(this, arguments);
            }
        };

        $realInput.off('blur', updateModel);
        if ($realInput.is(':focus')) {
            $realInput.on('blur', updateModel);
        } else {
            updateModel();
        }
    },

    updateModel: function(ev) {
        var $input = this.$(ev.currentTarget).hasClass('js-datepicker-input') ?
            this.$(ev.currentTarget).closest('.js-datepicker', this.el) :
            this.$(ev.currentTarget);
        var $realInput = $input.find('input');
        var attr = $realInput.length ?
            $realInput.attr('name') :
            ($input.data('attributeName') || $input.attr('name'));

        if ($input.hasClass('js-ignore')) {
            return;
        }

        if ($input.closest('.js-ext', this.el).length > 0) {
            return;
        }

        if (typeof attr === 'undefined') {
            return;
        }

        this.toggleError(attr);
        let value = this.getInputValue($input);

        this.model.set(attr, value);
        return this;
    },

    taint: function() {
        this.tainted = true;
    },

    untaint: function() {
        this.tainted = false;
    },

    toggleError: function(attribute, message) {
        this.$('[name=' + attribute + '], .js-attr-' + attribute)
            .closest('.form-group', this.$el)
            .toggleClass('has-error', message !== undefined);
        this.$('.error-' + attribute).text(message || '');

        if (!this.$('[name=' + attribute + ']').length && message) {
            this.showAlert(message);
        }
    },

    invalidAlert: function(message) {
        this.showAlert(message);
    },

    invalid: function(model, error = {}) {
        let noParsedError = true;
        if (Object.keys(error).indexOf('errors') >= 0) {
            error = error.errors || {};
            noParsedError = false;
        }

        if (noParsedError &&
            error.responseJSON &&
            error.responseJSON.error &&
            error.responseJSON.error.details) {
            error = error.responseJSON.error.details.messages || {};
        }

        Object.keys(error).forEach(attr => {
            let message = Array.isArray(error[attr]) ?
                            error[attr][0] : error[attr];
            this.toggleError(attr, message);
        });
    },

    valid: function(model) {
        const changes = model.changed || {};
        Object.keys(changes).forEach(attr => {
            this.toggleError(attr);
        });
    },

    remove: function() {
        Backbone.View.prototype.remove.apply(this, arguments);

        this.undelegateEvents();

        if (this.model) {
            this.unbindHandlers();
        }

        this.$el.remove();
    }
}), InputValueFormatMixin);



// WEBPACK FOOTER //
// ./app/commons/views/Edit.js